<template>
  <div id="app">
    <router-view :client="client" :useAnimations="useAnimations" :clients="clients" :totalGames="totalGames" :runningInApp="runningInApp" :highscoreRoom="highscoreRoom" :playerName="playerName" :highscores="highscores" :plays="plays" @closeChangeName="shouldSetUserName = false"></router-view>
    <div class="change-player-name" :class="{'show': shouldSetUserName}">
      Enter new name
      <input type="text" v-model="playerName" placeholder="playerName"></input>
      <button @click="savePlayerName">Save</button>
    </div>
    <div class="highscore-notification" :class="{'show': showNotification}">
      <template v-if="notification.rank > -1">
        <div class="highscore-rank">
          <div>
            <i class="fa fa-trophy" @click="showHighscore = true" aria-hidden="true" :class="{'gold': notification.rank === 1, 'silver': notification.rank === 2, 'bronze': notification.rank === 3}"></i> {{notification.rank}}.
          </div>
        </div>
        <div class="highscore-name">
          {{notification.name}}
        </div>
        <div class="highscore-score">
          {{notification.score}}
        </div>
      </template>
      <template v-if="notification.rank === -1">
        <div class="new-player-icon">
          <div>
            <i class="fas fa-user-plus" aria-hidden="true"></i>
          </div>
        </div>
        <div class="new-player-message">
          {{notification.name}}
        </div>
        <div></div>
      </template>
    </div>

  </div>
</template>

<script>
import storage from 'local-storage-fallback';

export default {
  name: 'app',
  data() {
    return {
      shouldSetUserName: false,
      playerName: '',
      client: null,
      highscoreRoom: null,
      highscoreNotification: null,
      showNotification: false,
      highscores: [],
      plays: [],
      clients: 0,
      totalGames: 0,
      screenWidth: 0,
      useAnimations: true,
      runningInApp: window.Android !== undefined || window.webkit !== undefined,
    };
  },
  created() {
    // console.log('created app'); //eslint-disable-line
    // // this.fixViewportHeight();


    // this.client = new Colyseus.Client(process.env.COMBO_BACKEND_WS);
    // this.highscoreRoom = this.client.join('highscore_room');


    // this.highscoreRoom.onError.add((e) => {
    //   console.log(this.client.id, 'couldnt join', e); //eslint-disable-line
    // });

    // this.client.onError.add((e) => {
    //   console.log(this.client.id, 'client error', e); //eslint-disable-line
    // });

    // this.client.onClose.add((e) => {
    //   console.log(this.client.id, 'client close', e); //eslint-disable-line
    // });

    // this.highscoreRoom.onJoin.add(() => {
    //   console.log(this.client.id, 'joined', this.highscoreRoom.name); //eslint-disable-line
    //   this.countUpGamesPlayed = this.highscoreRoom.data.totalGamesPlayed;
    //   this.countUpPlayersOnline(this.highscoreRoom.data.clients);
    // });


    // this.highscoreRoom.onLeave.add(() => {
    //   console.log(this.client.id, 'left', this.highscoreRoom.name);
    //   this.client.join('highscore_room');
    // });

    // this.highscoreRoom.onError.add(() => {
    //   console.log(this.client.id, 'error', this.highscoreRoom.name);
    //   this.client.join('highscore_room');
    // });

    // this.highscoreRoom.listen('clients', (entity) => {
    //   this.clients = entity.value;
    //   this.countUpPlayersOnline(entity.value);
    // });

    // // this.highscoreRoom.listen('totalGamesPlayed', 'add', (entity) => {
    // //   console.log('games played', entity); //eslint-disable-line
    // //   this.totalGames = entity;
    // //   // this.countUpGamesPlayed(entity);
    // // });

    // this.highscoreRoom.listen('totalGamesPlayed', (entity) => {
    //   console.log('games played', entity.value); //eslint-disable-line
    //   this.totalGames = entity.value;
    //   // this.countUpGamesPlayed(entity);
    // });

    // this.highscoreRoom.listen('highscores/:number', (change) => {
    //   this.displayNotification(change.value);
    // });
  },
  mounted() {
    this.highscore = parseFloat(storage.getItem('highscore') || 0);
    this.playerName = (storage.getItem('playerName') || this.getRandomPlayerName());
    this.useAnimations = (storage.getItem('useAnimations') || 'true') === 'true';

    starx.init({ host: 'api.cccombo.com', path: '/nano' }, () => {//eslint-disable-line
      starx.on('onNewUser', this.onNewUser);//eslint-disable-line
      starx.on("onTotalPlayedGames", this.onTotalPlayedGames);//eslint-disable-line
      starx.on("onHighScoreList", this.onHighScoreList);//eslint-disable-line
      starx.on("onGamesPlayedList", this.onGamesPlayedList);//eslint-disable-line
      starx.on("onNewHighScore", this.onNewHighScore);//eslint-disable-line
      starx.on("onPlayerCount", this.onPlayerCount);//eslint-disable-line
      starx.request('world.join', { name: this.playerName }, this.join);//eslint-disable-line
    });
  },
  methods: {
    onNewUser(data) {
      this.displayNotification({ name: data.name, rank: -1, score: -1 });
    },
    onTotalPlayedGames(data) {
      this.totalGames = data;
    },
    onPlayerCount(data) {
      this.clients = data;
    },
    onHighScoreList(data) {
      this.highscores = data;
    },
    onGamesPlayedList(data) {
      console.log('onGamesPlayedList', data);
      this.plays = data;
    },
    onNewHighScore(data) {
      console.log('onNewHighScore', data);
      this.displayNotification({ name: data.name.name, rank: data.rank, score: data.score });
    },
    join(data) {
      console.log(data);
      if (data.code === 0) {
        // v.messages.push({ name: 'system', content: data.result });
        console.log(data);
      }
    },
    savePlayerName() {
      this.shouldSetUserName = false;
      storage.setItem('playerName', this.playerName);
    },
    fixViewportHeight() {
      const clientWidth = (window.innerWidth ||
        document.documentElement.clientWidth || document.body.clientWidth);

      this.screenWidth = clientWidth;

      const html = document.querySelector('html');
      function onResize() {
        const width = (window.innerWidth ||
          document.documentElement.clientWidth || document.body.clientWidth);

        if (width !== this.screenWidth) {
          html.style.height = `${window.innerHeight}px`;
          this.screenWidth = width;
        }
      }
      window.addEventListener('resize', onResize);

      onResize();
    },
    countUpPlayersOnline(value) {
      for (let i = 0; i < (value - this.clients); i += 1) {
        setTimeout(() => {
          this.clients += 1;
        }, (20 * i));
      }
    },
    getRandomPlayerName() {
      this.shouldSetUserName = true;
      const playerName = `Player${Math.floor(Math.random() * 10000000) + 1}`;
      storage.setItem('playerName', playerName);
      return playerName;
    },
    displayNotification(notification) {
      this.highscoreNotification = notification;
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 3500);
    },
  },
  computed: {
    notification() {
      return this.highscoreNotification || { name: '', score: 0, rank: -1 };
    },
  },
  watch: {
    $route(to, from) {
      if (from.path === '/' && to.path === '/game' && this.shouldSetUserName) this.shouldSetUserName = false;
    },
  },
};
</script>

<style lang="less">
@pink: #c2185b;

@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600|Raleway:100,500');
* {
  box-sizing: border-box;
  outline: none; // -webkit-touch-callout: none;
  // -webkit-user-select: none;
  // -khtml-user-select: none;
  // -moz-user-select: none;
  // -ms-user-select: none;
  // user-select: none;
  -webkit-tap-highlight-color: transparent;
}

body,
html {
  margin: 0;
  padding: 0;
  color: #fff;
  background: #eee;
  font-family: 'Raleway', 'Open Sans', sans-serif;
  font-weight: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  @media (min-width: 769px) {
    height: 100%;
    width: 100%;
    position: relative;
    top: initial;
    left: initial;
    right: initial;
    bottom: initial;
    overflow: hidden;
  }
}

#app {
  background: #262626;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  @media (min-width: 769px) {
    height: 100%;
    width: 100%;
    max-width: 450px;
    max-height: 750px;
    border-radius: 5px;
    position: relative;
    top: initial;
    left: initial;
    right: initial;
    bottom: initial;
    overflow: hidden;
  }
}

h1,
h2,
h3 {
  font-family: 'Raleway', 'Open sans', sans-serif;
  font-weight: 100;
}

h2 {
  text-align: center;
  font-weight: 300;
  line-height: 1;
  font-size: 2rem;
  margin: 0;
}

.change-player-name {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: #1f1f1f;
  transform: translateY(-100%);
  transition: all ease 0.3s;
  padding: 2rem;
  font-size: 1.25rem;
  font-weight: 300;
  text-transform: uppercase;
  text-align: center;
  z-index: 6;

  input {
    border-radius: 0.25rem;
    width: 100%;
    display: block;
    padding: 0.75rem;
    border: none;
    margin: 0.75rem 0;
  }

  button {
    margin: 0;
  }
  &.show {
    transform: translateY(0);
  }
}

.game,
.page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
  background: #1f1f1f;

  footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }

  header {
    display: flex;
    font-size: 2rem;
    font-weight: 300;
    padding: 1rem;
    align-items: center;
    justify-content: center;
    background: #262626;
    position: relative;
    z-index: 2;
    cursor: default;

    .combo-progress-wrapper {
      position: absolute;
      bottom: 0.25rem;
      left: 1rem;
      right: 1rem;

      background: rgba(255, 255, 255, 0.3);
      height: 1px;

      .progress {
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        width: 0%;
        background: #fff;
        transition: all ease 0.3s;
      }
    }
    p,
    span {
      text-transform: uppercase;
      font-size: 0.7rem;
      margin: 0;
    }
    .center {
      text-align: center;
      display: inline-block;
    }
    div {
      flex: 1;
      &.level {
        text-align: center; // font-size: 2.8rem;
        cursor: pointer;
      }
      &.clicks-left {
        text-align: right;
      }
    }
  }
  .menu,
  .start-menu {
    background: #262626;
    border-radius: 5px;
    padding: 2rem;
    z-index: 3;
    position: absolute;
    display: flex;
    flex-direction: column;
    font-size: 1.25rem;
    font-weight: 300;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    visibility: hidden;
    opacity: 0;
    transition: all ease 0.3s;
    &.show {
      visibility: visible;
      opacity: 1;
    }
  }
  .menu {
    &.show {
      transition: all ease 0.3s 0.5s;
    }
  }
  .menu {
    visibility: visible;
    opacity: 1;
  }
  .start-menu {
    .logo {
      margin-bottom: 8rem;
      display: flex;
      width: 100%;

      div {
        flex: 1;
        padding: 0.25rem;

        span {
          text-align: center;
          padding: 1rem 0;
          width: 100%;
          justify-content: center;
          background: #fff;
          box-shadow: 0 5px 0 darken(#fff, 15%);
          color: #333;
        }
      }
    }

    .toolbar {
      width: 100%;
      margin-top: 2rem;
      i {
        font-size: 2rem;
        cursor: pointer;
        &.pulsate {
          -webkit-animation: pulsate 1s ease-out;
          -webkit-animation-iteration-count: 3;
        }

        &.disabled {
          opacity: 0.5;
          cursor: default;
        }
      }
      display: flex;
      justify-content: center;
      div {
        padding: 0 1.5rem;
      }
    }
    span {
      padding: 1rem;
      background: #388e3c;
      font-size: 1rem;
      font-weight: 300; // color: #333;
      display: flex;

      color: #fff;
      justify-content: center;
      align-items: center;
      position: relative;
      border-radius: 5px;
      display: inline-block;
      border: none;
      box-shadow: 0 5px 0 darken(#388e3c, 15%);
    }
  }
}

@-webkit-keyframes pulsate {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    opacity: 0;
  }
}

.full-width {
  width: 100%;
}

.game.animate {
  .button,
  button {
    transition: all ease 0.3s;
  }
}

.button,
button {
  border-radius: 5px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  border: none;
  text-decoration: none;
  text-align: center;
  padding: 1rem;
  font-size: 0.9rem;
  background: #c2185b;
  margin-bottom: 2rem;
  font-family: 'Open sans', sans-serif;
  cursor: pointer;
  box-shadow: 0 5px 0 darken(#c2185b, 15%);
  width: 100%;
  &:hover {
    background: lighten(#c2185b, 5%);
  }
  &:active,
  &focus {
    outline: none;
    box-shadow: 0 2px 0 darken(#c2185b, 15%);
  }
  &.blue {
    background: #1976d2;
    box-shadow: 0 5px 0 darken(#1976d2, 15%);
    &:hover {
      background: lighten(#1976d2, 5%);
    }
    &:active,
    &focus {
      box-shadow: 0 2px 0 darken(#1976d2, 15%);
    }
  }
}

.board {
  // display: flex;
  // flex-wrap: wrap;
  width: 100%; // flex-grow: 2;
  // align-items: stretch;
  overflow: hidden;
  padding: 0.5rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  padding-top: 95px;
  padding-bottom: 95px;
}

.highscore-notification {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  background: #262626;
  display: flex;
  padding: 0.5rem 1rem;
  transition: all ease 0.5s;
  transform: translateY(-100%);

  i {
    color: #fff;

    &.gold {
      color: gold;
    }
    &.silver {
      color: silver;
    }
    &.bronze {
      color: brown;
    }
  }

  & > div {
    flex: 1;

    &.highscore-name {
      text-align: center;
    }

    &.highscore-score {
      text-align: right;
    }
  }

  .new-player-icon {
    i {
      color: #fff;
    }
  }

  &.show {
    transform: translateY(0);
  }
}

.logo-big {
  position: fixed;
  top: 5rem;
  display: flex;
  width: 600px;
  left: 5rem; // margin-left: -300px;
  height: 50px;

  div {
    flex: 1;
    font-weight: 300; // color: #333;
    display: flex;
    color: #fff;
    justify-content: center;
    align-items: center;
    position: relative;
    display: inline-block;
    border: none;
    span {
      text-align: center;
      padding: 1.7rem 1.5rem;
      width: 100%;
      text-transform: uppercase;
      background: #fff;
      color: #333;
      font-size: 2rem;
      border-radius: 5px;
      box-shadow: 0 5px 0 #d9d9d9;
      font-weight: bold;
    } // &:first-child {
    //   transform: rotate(20deg);
    // }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?cdc1f2a2